import { axiosInstance } from '@/rest'

// PnL REST API client

const createPnlApi = () => {
  return {
    /**
     * List FIFO-matched closed lots (realized PnL) for an account
     * @param {string} accountNumber
     * @param {Object} params Query params (sub_account_ids[], start_date, end_date, symbol, limit, offset, order_by, sort_direction)
     */
    getLots: (accountNumber, params = {}) => {
      const searchParams = new URLSearchParams()
      Object.entries(params).forEach(([key, value]) => {
        if (value === undefined || value === null || value === '') return
        if (Array.isArray(value)) {
          value.forEach((v) => searchParams.append(key, v))
        } else {
          searchParams.append(key, value)
        }
      })
      return axiosInstance.get(
        `pnl/lots/${accountNumber}?${searchParams.toString()}`
      )
    },
    /**
     * Realized PnL summary for an account: top-level totals plus a paginated
     * per-(symbol, leg_type) breakdown.
     * @param {string} accountNumber
     * @param {Object} params Query params (sub_account_ids[], start_date, end_date, symbol, limit, offset, order_by, sort_direction)
     */
    getSummary: (accountNumber, params = {}) => {
      const searchParams = new URLSearchParams()
      Object.entries(params).forEach(([key, value]) => {
        if (value === undefined || value === null || value === '') return
        if (Array.isArray(value)) {
          value.forEach((v) => searchParams.append(key, v))
        } else {
          searchParams.append(key, value)
        }
      })
      return axiosInstance.get(
        `pnl/summary/${accountNumber}?${searchParams.toString()}`
      )
    },
  }
}

const pnlApi = createPnlApi()

export { pnlApi }
